import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import { MailingEditor } from './components';
import SimpleBackdrop from 'src/components/Backdrop';
import useMail from 'src/hooks/useMail';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(3),
    },
}));

export const MailingView = () => {
    const classes = useStyles();
    const { loading } = useMail();

    return (
        <Page className={classes.root} title="Mailing">
            <SimpleBackdrop loading={loading} />
            <Container maxWidth={false}>
                <MailingEditor />
            </Container>
        </Page>
    );
};
